import { render } from "./rbac.authorization.k8s.io.clusterrole.vue?vue&type=template&id=3f54df84"
import script from "./rbac.authorization.k8s.io.clusterrole.vue?vue&type=script&lang=js"
export * from "./rbac.authorization.k8s.io.clusterrole.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__